import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { conditions } from "../../conditions/conditions";
import { ConditionName } from "../../../interfaces/enums";
import { API, getApiUrls } from "../../../services/services";
import { combinedMarkers, getAllGeneralMarker, getAllPersonalMarkers } from "../../../redux/actions/videoData.actions";
import { compare, responseValidator } from "../../helpers";
import { setMarkers } from "../../../redux/slices/videoDataSlice";
import { IMarker } from "interfaces";
import { shallowEqual } from "react-redux";

const useGetMarkers = () => {
    const dispatch = useAppDispatch();
    const { params, isFetchDetails } = useAppSelector(({ videoData: { params, isFetchDetails } }) => ({ params, isFetchDetails }), shallowEqual);
    const { isLogin } = useAppSelector(({ user: { isLogin } }) => ({ isLogin }), shallowEqual);
    const { loadedFragmentsCount } = useAppSelector(({ controller: { loadedFragmentsCount } }) => ({ loadedFragmentsCount }), shallowEqual);

    useEffect(() => {
        if (conditions(ConditionName.getMarkers) && conditions(ConditionName.hasPermittedLoadedFragment)) {
            if (conditions(ConditionName.isLogin)) {
                (async () => {
                    try {
                        const response: any = await getAllGeneralMarker(getApiUrls().apiMarkerUrl + Number(params.id) + "/");
                        if (conditions(ConditionName.trackerEnabled)) {
                            const { data, status } = await getAllPersonalMarkers(API().user.getPersonalMarker);
                            if (responseValidator(status)) {
                                combinedMarkers(
                                    data,
                                    response.map((m: IMarker) => {
                                        return { ...m, isPersonal: null };
                                    })
                                );
                            } else
                                dispatch(
                                    setMarkers(
                                        response.map((m: IMarker) => {
                                            return { ...m, isPersonal: null };
                                        })
                                    )
                                );
                        } else
                            dispatch(
                                setMarkers(
                                    response.map((m: IMarker) => {
                                        return { ...m, isPersonal: null };
                                    })
                                )
                            );
                    } catch (error) {
                        if (conditions(ConditionName.trackerEnabled)) {
                            const { data, status } = await getAllPersonalMarkers(API().user.getPersonalMarker);
                            if (responseValidator(status)) {
                                combinedMarkers(data, []);
                            }
                        }
                    }
                })();
            } else {
                (async () => {
                    const response: any = await getAllGeneralMarker(getApiUrls().apiMarkerUrl + Number(params.id) + "/");
                    dispatch(setMarkers(response.sort(compare)));
                })();
            }
        }
    }, [!!params.isMarkersChange, isFetchDetails, isLogin, loadedFragmentsCount.length]);
};

export default useGetMarkers;
